<template>
  <div class="yt-subject-list">
    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="SubjectList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="subjectsCms"
      :columns="columns"
      :schema="schema"
      :hasDeleteItem="true"
      :supportImport="true"
      :filterDataImport="onFilterDataImport"
      :actionImportFile="onActionImportFile"
      :actionEndImportFile="onActionEndImportFile"
      :defaultServerParams="{
        _fields:
          '_id,name,school._id,school.name,code,isActive,group._id,group.name,grade._id,grade.name,createdAt',
        schoolId: filteredBySchool,
        isDeleted: false
      }"
      @setModeSchema="onSetModeSchema"
      @modelUpdated="onModelUpdated"
    >
      <template slot="import_append">
        <p class="mt-3 mb-3">
          Already existent course name wil be replaced if it already exists.
        </p>
        <label>
          New course status
          <input
            type="checkbox"
            v-model="importEnabledItems"
            class="checkbox ml-1 mr-1"
          />
          Enabled
        </label>
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VueFormGenerator from 'vue-form-generator'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')
const subjectsModule = namespace('subjects')

@Component()
export default class SubjectList extends BaseList {
  @appModule.State('schools') stateSchools
  @appModule.State('filterBySchool') stateFilterBySchool
  @appModule.State('userProfile') stateUserProfile
  @subjectsModule.State('groups') stateCurrentGroups
  @subjectsModule.State('grades') stateCurrentGrades

  @subjectsModule.Mutation('setGroups') mutationGroups
  @subjectsModule.Mutation('setGrades') mutationGrades

  @appModule.Action('getSchools') actionGetSchools
  @subjectsModule.Action('getGroups') actionGetGroups
  @subjectsModule.Action('getGrades') actionGetGrades

  title = 'Courses'

  importEnabledItems = true

  columns = [
    {
      label: 'ID',
      field: '_id',
      hidden: true
    },
    {
      label: 'Active',
      field: 'isActive',
      type: 'switch'
    },
    {
      label: 'School',
      field: 'school.name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by School', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        filterDropdownItems: [], // dropdown (with selected values) instead of text input
        isMultiselect: true,
        fieldNameFilter: 'schoolId'
        // filterFn: this.columnFilterFn, // custom filter function that
        // trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    {
      label: 'Name',
      field: 'name',
      filterOptions: {
        enabled: true, // enable filter for this column
        placeholder: 'Filter by Name', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    // {
    //   label: 'Course Id',
    //   field: 'code',
    //   filterOptions: {
    //     enabled: true, // enable filter for this column
    //     placeholder: 'Filter by Course Id', // placeholder for filter input
    //     filterValue: '', // initial populated value for this filter
    //     trigger: 'keyup' // only trigger on enter not on keyup
    //   }
    // },
    {
      label: 'Subject',
      field: 'group.name',
      filterOptions: {
        enabled: false, // enable filter for this column
        placeholder: 'Filter by Group', // placeholder for filter input
        filterValue: '', // initial populated value for this filter
        filterDropdownItems: [], // dropdown (with selected values) instead of text input
        isMultiselect: true,
        fieldNameFilter: 'groupId'
        // filterFn: this.columnFilterFn, // custom filter function that
        // trigger: 'keyup' // only trigger on enter not on keyup
      }
    },
    // {
    //   label: 'Grade',
    //   field: 'grade.name',
    //   filterOptions: {
    //     enabled: false, // enable filter for this column
    //     placeholder: 'Filter by Grade', // placeholder for filter input
    //     filterValue: '', // initial populated value for this filter
    //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
    //     isMultiselect: true,
    //     fieldNameFilter: 'gradeId'
    //     // filterFn: this.columnFilterFn, // custom filter function that
    //     // trigger: 'keyup' // only trigger on enter not on keyup
    //   }
    // },
    {
      label: 'Actions',
      field: 'actions'
    }
  ]

  schema = {
    fields: [
      {
        // label: 'ID (disabled text field)',
        model: '_id',
        type: 'input',
        inputType: 'hidden',
        readonly: true
        // disabled: true
      },
      {
        label: 'Name',
        model: 'name',
        type: 'input',
        inputType: 'text',
        placeholder: 'Subject name',
        required: true,
        validator: VueFormGenerator.validators.string.locale({
          // fieldIsRequired: 'The name is required!'
        })
      },
      {
        label: 'Course Id',
        model: 'code',
        type: 'input',
        inputType: 'text',
        placeholder: 'Course Id',
        required: true,
        validator: ['string']
      },
      {
        label: 'School',
        model: 'schoolId',
        type: 'select',
        featured: true,
        required: true,
        // values: function () {
        //     return [
        //         { id: 'superadmin', name: 'Super Admin' }
        //     ]
        // },
        validator: VueFormGenerator.validators.required.locale({
          fieldIsRequired: 'School is required!'
        })
        // disabled: true
      },
      {
        label: 'Group',
        model: 'groupId',
        type: 'select',
        featured: true,
        required: true,
        validator: VueFormGenerator.validators.required.locale({
          fieldIsRequired: 'Group is required!'
        })
      },
      {
        label: 'Grade',
        model: 'gradeId',
        type: 'select',
        featured: true
      },
      {
        label: 'Active',
        model: 'isActive',
        type: 'switch',
        default: false,
        textOn: 'Active',
        textOff: 'Inactive'
      }
    ]
  }

  onActionImportFile() {
    if (!this.filteredBySchool) {
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Please first select a school from the top dropdown.'
      })

      return false
    }

    return true
  }

  onActionEndImportFile() {
    this.componentKey++
  }

  onFilterDataImport(data) {
    return {
      data,
      schoolId: this.filteredBySchool,
      enabledItems: this.importEnabledItems
    }
  }

  onModelUpdated(schema, newVal) {
    if (schema === 'schoolId') {
      this.mutationGroups([])
      this.mutationGrades([])
      this.actionGetGroups(newVal)
      this.actionGetGrades(newVal)
    }
  }

  onSetModeSchema(mode) {
    if (mode === 'update') {
      const refGridTable = this.$refs.gridTable

      const school = refGridTable.getFieldDataSelectedRow('school')
      if (typeof school === 'object' && school.hasOwnProperty('_id')) {
        refGridTable.setFieldDataSelectedRow('schoolId', school._id)
        this.actionGetGroups(school._id)
        this.actionGetGrades(school._id)
      }

      const group = refGridTable.getFieldDataSelectedRow('group')
      if (typeof group === 'object' && group.hasOwnProperty('_id')) {
        refGridTable.setFieldDataSelectedRow('groupId', group._id)
      }

      const grade = refGridTable.getFieldDataSelectedRow('grade')
      if (typeof grade === 'object' && grade.hasOwnProperty('_id')) {
        refGridTable.setFieldDataSelectedRow('gradeId', grade._id)
      }
    } else if (mode === 'add') {
      this.mutationGroups([])
      this.mutationGrades([])
    }
  }

  @Watch('stateUserProfile', { immediate: true })
  refreshSchools() {
    if (this.stateUserProfile && this.stateUserProfile.role === 'superadmin') {
      this.actionGetSchools()
    }
  }

  @Watch('stateCurrentGroups', { immediate: true })
  loadGroups() {
    this.schema.fields.find(item => item.model === 'groupId').values = () => {
      return this.stateCurrentGroups
    }

    /* const filterList = response.data.result.map((item) => {
            return { value: item._id, text: item.name }
        })

        this.columns.find(item => item.field === 'school.name').filterOptions.filterDropdownItems = filterList */
  }

  @Watch('stateCurrentGrades', { immediate: true })
  loadGrades() {
    this.schema.fields.find(item => item.model === 'gradeId').values = () => {
      return this.stateCurrentGrades
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/subjects/SubjectList.vue